import {OneTrustCategoryType} from 'types/types';

export const SESSION_STORAGE_POST_PURCHASE_ORDER_DATA = 'session_storage_pp_order_data';
export const PURCHASE_STORAGE = 'PURCHASE_STORAGE';
export const PAYPAL_BUTTON_POSITION = 'paypal_button_position';
export const IS_OTTICA_DIMENSION_EVENT = 'isOtticaDimensionEvent';

export const PERFORMANCE_COOKIES = 'C0002';
export const FUNCTIONAL_COOKIES = 'C0003';
export const TARGETING_COOKIES = 'C0004';

export const CATEGORY: OneTrustCategoryType = {
    [FUNCTIONAL_COOKIES]: 'OneTrust:optanon-category-C0003',
    [PERFORMANCE_COOKIES]: 'OneTrust:optanon-category-C0002',
    [TARGETING_COOKIES]: 'OneTrust:optanon-category-C0004',
};

export const ONETRUST_COOKIE = 'OptanonConsent';

export const CONVERSION_TRACKING_ID_SALE = 3712;
export const CONVERSION_TRACKING_ID_EMAIL_LEAD = 5749;
export const DATALAYER_EMAIL = 'datalyer_email';
export const IRE_CLICK_ID = 'ire_click_id';

export const LOCAL_STORAGE_CHECKOUT = 'local_storage_checkout';
export const LOCAL_STORAGE_ORDER_DATA = 'local_storage_order_data';

export const SUBSCRIPTION_LOCATION: {[key: string]: string} = {
    checkout: 'Checkout',
    footer: 'Footer',
    oneTap: 'Google One Tap',
    signup: 'Create Account',
};
